// quickPickUpgradeNotice.pt-br.js
// Portuguese (Brazilian) translations for QuickPickUpgradeNotice component

export const quickPickUpgradeNoticePtBR = {
  // Main messages
  "Quick Picks Limit Reached": "Limite de Escolhas Rápidas Atingido",
  "You've used your daily Quick Picks. Get more with Star Coins!": "Você usou suas Escolhas Rápidas diárias. Obtenha mais com Star Coins!",
  "You've reached your daily Quick Pick limit. Get instant access with Star Coins!": "Você atingiu seu limite diário de Escolhas Rápidas. Tenha acesso instantâneo com Star Coins!",
  
  // Dynamic sport messages
  "Get More Sports Quick Picks!": "Obtenha Mais Escolhas Rápidas de Esportes!",
  "Get More NFL Quick Picks!": "Obtenha Mais Escolhas Rápidas da NFL!",
  "Get More MLB Quick Picks!": "Obtenha Mais Escolhas Rápidas da MLB!",
  "Get More Soccer Quick Picks!": "Obtenha Mais Escolhas Rápidas de Futebol!",
  "Get More MMA Quick Picks!": "Obtenha Mais Escolhas Rápidas de MMA!",
  "Get More NCAAF Quick Picks!": "Obtenha Mais Escolhas Rápidas de Futebol Americano Universitário!",
  
  // Subtitles
  "Each Quick Pick saves to your chat history": "Cada Escolha Rápida salva no seu histórico de chat",
  "AI-powered predictions saved to chat history": "Previsões com IA salvas no histórico de chat",
  
  // Button text
  "Buy More Star Coins to Continue Picking": "Compre Mais Star Coins para Continuar Escolhendo",
  "Maybe Later": "Talvez Depois",
  
  // Info text
  "7 coins / quick pick": "7 moedas / escolha rápida",
  
  // General
  "Close": "Fechar"
};